import { render, staticRenderFns } from "./BaseProductSlider.vue?vue&type=template&id=0f0765d2&"
import script from "./BaseProductSlider.vue?vue&type=script&lang=js&"
export * from "./BaseProductSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0765d2')) {
      api.createRecord('0f0765d2', component.options)
    } else {
      api.reload('0f0765d2', component.options)
    }
    module.hot.accept("./BaseProductSlider.vue?vue&type=template&id=0f0765d2&", function () {
      api.rerender('0f0765d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductSlider.vue"
export default component.exports